
    (window.__NEXT_P = window.__NEXT_P || []).push([
      "/data",
      function () {
        return require("private-next-pages/data.jsx");
      }
    ]);
    if(module.hot) {
      module.hot.dispose(function () {
        window.__NEXT_P.push(["/data"])
      });
    }
  